import React from "react";
import { useTranslation } from "react-i18next";

// prefer webp with png fallback
const bg = (webp, png) => ({
  backgroundImage: `image-set(url('${webp}') type('image/webp'), url('${png}') type('image/png'))`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});

export default function ThoughtLeadershipSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16">
      <div className="relative contain mx-auto">
        {/* Title */}
        <div className="text-center pt-6 pb-6">
          <h2 className="heading3 font-bold">{t("thought_leadership.title")}</h2>
        </div>

        {/* Desc */}
        <div className="text-center pb-8 md:pb-12">
          <p>{t("thought_leadership.desc")}</p>
        </div>

        {/* Row (use your grid-12 system so cards sit side-by-side) */}
        <div className="row grid-12 xs:grid-12 sm:grid-12 md:grid-12 lg:grid-12 xl:grid-12 flex-wrap md:flex flex -mx-2">
          {/* Card 1 */}
          <div className="cols-12 md:cols-4 px-2 expand-h-full mb-4 md:mb-0">
            <a
              href="/company/innovation"
              target="_blank"
              rel="noreferrer"
              className="block h-full wd-rounded-[16px] overflow-hidden wd-bg-[#F2F3F3]"
            >
              <div
                className="w-full h-56 md:h-64"
                style={bg(
                  "https://www.westerndigital.com/content/dam/store/en-us/assets/company/company-overview-innovation.png.wdthumb.1280.1280.webp",
                  "https://www.westerndigital.com/content/dam/store/en-us/assets/company/company-overview-innovation.png.thumb.1280.1280.png"
                )}
                aria-hidden="true"
              />
              <div className="px-6 py-6 flex flex-col">
                <h2 className="heading4 heading-mb-2">{t("thought_leadership.cards.innovation.title")}</h2>
                <p className="">{t("thought_leadership.cards.innovation.desc")}</p>
                <span className="inline-flex border border-black text-black py-2 md:py-3 px-4 md:px-10 mt-4 md:mt-6 mb-9 md:mb-0 self-start wd-rounded-[6px]">
                  {t("thought_leadership.cards.cta")}
                </span>
              </div>
            </a>
          </div>

          {/* Card 2 */}
          <div className="cols-12 md:cols-4 px-2 expand-h-full mb-4 md:mb-0">
            <a
              href="https://investor.wdc.com/"
              target="_blank"
              rel="noreferrer"
              className="block h-full wd-rounded-[16px] overflow-hidden wd-bg-[#F2F3F3]"
            >
              <div
                className="w-full h-56 md:h-64"
                style={bg(
                  "https://www.westerndigital.com/content/dam/store/en-us/assets/company/company-overview-investor-relations.png.wdthumb.1280.1280.webp",
                  "https://www.westerndigital.com/content/dam/store/en-us/assets/company/company-overview-investor-relations.png.thumb.1280.1280.png"
                )}
                aria-hidden="true"
              />
              <div className="px-6 py-6 flex flex-col">
                <h2 className="heading4 heading-mb-2">{t("thought_leadership.cards.investor.title")}</h2>
                <p className="">{t("thought_leadership.cards.investor.desc")}</p>
                <span className="inline-flex border border-black text-black py-2 md:py-3 px-4 md:px-10 mt-4 md:mt-6 mb-9 md:mb-0 self-start wd-rounded-[6px]">
                  {t("thought_leadership.cards.cta")}
                </span>
              </div>
            </a>
          </div>

          {/* Card 3 */}
          <div className="cols-12 md:cols-4 px-2 expand-h-full mb-4 md:mb-0">
            <a
              href="/company/corporate-responsibility"
              target="_blank"
              rel="noreferrer"
              className="block h-full wd-rounded-[16px] overflow-hidden wd-bg-[#F2F3F3]"
            >
              <div
                className="w-full h-56 md:h-64"
                style={bg(
                  "https://www.westerndigital.com/content/dam/store/en-us/assets/company/company-overview-corporate-reponsibility.png.wdthumb.1280.1280.webp",
                  "https://www.westerndigital.com/content/dam/store/en-us/assets/company/company-overview-corporate-reponsibility.png.thumb.1280.1280.png"
                )}
                aria-hidden="true"
              />
              <div className="px-6 py-6 flex flex-col">
                <h2 className="heading4 heading-mb-2">{t("thought_leadership.cards.cr.title")}</h2>
                <p className="">{t("thought_leadership.cards.cr.desc")}</p>
                <span className="inline-flex border border-black text-black py-2 md:py-3 px-4 md:px-10 mt-4 md:mt-6 mb-9 md:mb-0 self-start wd-rounded-[6px]">
                  {t("thought_leadership.cards.cta")}
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
